import { render, staticRenderFns } from "./StrangeBelongingsTool.vue?vue&type=template&id=005905ec&"
import script from "./StrangeBelongingsTool.vue?vue&type=script&lang=js&"
export * from "./StrangeBelongingsTool.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports